import React, { useEffect, useState } from 'react';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import { Backdrop, Box, Button, Grid, MenuItem, Paper, TextField, Typography } from '@material-ui/core';
import axios_instance from '../../../services/auth/jwt/config';
import WarnMissing from '../../../f5/shared/WarnMissing';
import Editor from 'react-simple-wysiwyg';
import { Save } from '@material-ui/icons';
import { enqueueSnackbar } from 'notistack';
import SimpleLoader from '../../../f5/shared/SimpleLoader';

interface InformationProps {

}

export default function Information({ ...props }: InformationProps) {
    const [informations, setInformations] = useState<any[]>([]);
    const [services, setServices] = useState<any[]>([]);
    const [departaments, setDepartments] = useState<any[]>([]);
    const [departamentSelected, setDepartamentSelected] = useState<number | null>(null);
    const [serviceSelected, setServiceSelected] = useState<number | null>(null);
    const [infoSelected, setInfoSelected] = useState<string | null>(null);
    const [data, setData] = useState<any>({});
    const [success, setSuccess] = useState({ has: false, message: '' })
    const [loading, setLoading] = useState({ is: false, message: '' })
    const [error, setError] = useState({ has: false, message: '' })

    useEffect(() => {
        setLoading({ is: true, message: 'Carregando informações...' });
        axios_instance.get<{ success: boolean; informations: any[]; services: any[], departaments: any[], message?: string }>('ouvidoria/servicos/informacoes/index').then((response) => {
            let r = response.data;
            if (r.success) {
                setInformations(r.informations);
                setServices(r.services);
                setDepartments(r.departaments);
            } else {
                enqueueSnackbar(r?.message, { variant: 'error' });
            }
        }).catch((error) => {
            enqueueSnackbar('Erro ao carregar informações!', { variant: 'error' });
        }).finally(() => {
            setLoading({ is: false, message: '' });
        });
    }, [])

    useEffect(() => {
        if (serviceSelected) {
            setLoading({ is: true, message: 'Carregando informações do serviço...' });
            axios_instance.get<{ success: boolean; data: any, message?: string }>(`ouvidoria/servicos/informacoes/show/${serviceSelected}`).then((response) => {
                let r = response.data;
                if (r.success) {
                    setData(r.data);
                } else {
                    enqueueSnackbar(r?.message, { variant: 'error' });
                }
            }).finally(() => {
                setLoading({ is: false, message: '' });
            });
        }
    }, [serviceSelected])

    const onSave = () => {
        setLoading({ is: true, message: 'Salvando informações...' });
        axios_instance.post<{ success: boolean; message: string }>(`ouvidoria/servicos/informacoes/update/${serviceSelected}`, {
            informacao: data
        }).then((response) => {
            let r = response.data;
            if (r.success) {
                enqueueSnackbar('Informações salvas com sucesso!', { variant: 'success' });
            } else {
                enqueueSnackbar(r.message, { variant: 'error' });
            }
        }).catch((error) => {
            enqueueSnackbar('Erro ao salvar informações!', { variant: 'error' });
        }).finally(() => {
            setLoading({ is: false, message: '' });
        });
    }

    return <PageContainer>
        <Backdrop open={loading.is} style={{ zIndex: 1000 }}>
            <SimpleLoader
                customMessage={loading.message}
            />
        </Backdrop>
        <Box>
            <Paper>
                <Typography variant="h4" component="h2" style={{ padding: '16px', fontWeight: 'bold' }}>
                    Informações de Serviços
                </Typography>
                <Box p={2}>
                    <TextField
                        label="Selecione um departamento"
                        select
                        fullWidth
                        variant="outlined"
                        value={departamentSelected || ''}
                        onChange={(e) => {
                            const value = e.target.value;
                            setDepartamentSelected(value ? Number(value) : null);
                            setServiceSelected(null); // Reset service selection when department changes
                        }}
                    >
                        {departaments.map((departament) => (
                            <MenuItem key={departament.id} value={departament.id}>
                                {departament.nome}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Selecione um serviço"
                        select
                        fullWidth
                        variant="outlined"
                        value={serviceSelected || ''}
                        onChange={(e) => {
                            const value = e.target.value;
                            setServiceSelected(value ? Number(value) : null);
                        }}
                    >
                        {services.map((service) => {
                            if (departamentSelected && service.ouv__departamento_id !== departamentSelected) {
                                return null;
                            }
                            return <MenuItem key={service.id} value={service.id}>
                                {service.nome}
                            </MenuItem>
                        })}
                    </TextField>
                    <Box mt={2}>
                        {serviceSelected ? <Box>
                            <Grid container spacing={2}>
                                {informations.map((info) => <Grid
                                    item xs={12} sm={6}
                                    key={info.interno}
                                >
                                    <Typography variant="h6" style={{ marginTop: '16px', fontWeight: 'bold' }}>
                                        {info.name}
                                    </Typography>
                                    <Editor
                                        value={data[info.interno] || ''}
                                        onChange={(e) => {
                                            setData({ ...data, [info.interno]: e.target.value });
                                        }}
                                    />
                                </Grid>)}
                            </Grid>
                            {/* <Box display="flex" flexWrap="wrap" gridGap={2} my={2}>
                                {informations.map((info) => <Button
                                    variant={infoSelected === info.interno ? 'contained' : 'outlined'}
                                    color={infoSelected === info.interno ? 'primary' : 'default'}
                                    onClick={() => setInfoSelected(info.interno)}
                                    key={info.interno}
                                >
                                    {info.name}
                                </Button>)}
                            </Box>
                            {infoSelected ? <Editor
                                value={data[infoSelected] || ''}
                                onChange={(e) => {
                                    setData({ ...data, [infoSelected]: e.target.value });
                                }}
                            /> : <WarnMissing
                                title="Selecione uma informação para editar."
                                fullWidth
                            />} */}
                            <Box display="flex" justifyContent="flex-end" mt={2}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={onSave}
                                    startIcon={<Save />}
                                >
                                    Salvar
                                </Button>
                            </Box>
                        </Box> : <WarnMissing
                            title="Selecione um serviço para ver as informações."
                            fullWidth
                        />}
                    </Box>
                </Box>
            </Paper>
        </Box >
    </PageContainer >
}